import React, { useContext, useState } from 'react'
import { Col, Row, Card, Table, Button, Form } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../components/Pagination'
import { Context } from '../Statistic'
import { useCookies } from 'react-cookie'
import { batchRecalculateReward } from '../../../../controller/api/__loto__/reward'
import { parseQuery } from '../../../../helper/helper'
import { useLocation } from 'react-router-dom'

const _Table = () => {

  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(['lottmekong'])
  const location = useLocation()
  const [processingId, setProcessingId] = useState('')
  const [selectedIds, setSelectedIds] = useState([])

  const queryObj = parseQuery(location.search)
  const eligibleIds = state.data.list
    ? state.data.list.filter((item) => item.status === 4 || item.status === 5).map((item) => item.id)
    : []
  const isAllSelected = eligibleIds.length > 0 && eligibleIds.every((id) => selectedIds.includes(id))

  const onSelect = (ticketId, isChecked) => {
    if (isChecked) {
      setSelectedIds((current) => [...current, ticketId])
      return
    }

    setSelectedIds((current) => current.filter((id) => id !== ticketId))
  }

  const onSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedIds(eligibleIds)
      return
    }

    setSelectedIds([])
  }

  const refreshData = () => {
    setSelectedIds([])
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: state.filter
    })
  }

  const onBatchRecalculateSelected = async () => {
    if (selectedIds.length === 0) {
      alert('Vui lòng chọn ít nhất một vé')
      return
    }

    if (!window.confirm(`Bạn có chắc muốn đưa ${selectedIds.length} vé đã chọn về trạng thái chờ tính lại?`)) return

    setProcessingId('batch-selected')

    try {
      const response = await batchRecalculateReward(cookies.lottmekong, {
        ticketIds: selectedIds
      })

      if (response && response.status === 1) {
        alert(`${response.message || 'Tính thưởng lại thành công'}${response.skippedCount ? `\nBỏ qua: ${response.skippedCount} vé` : ''}`)
        refreshData()
      } else {
        alert(response?.message || 'Lỗi tính lại thưởng')
      }
    } catch (error) {
      alert('Lỗi tính lại thưởng')
    }

    setProcessingId('')
  }

  const onBatchRecalculateAll = async () => {
    if (!queryObj.resultId) {
      alert('Không tìm thấy resultId hiện tại')
      return
    }

    if (!window.confirm('Bạn có chắc muốn đưa toàn bộ vé của kỳ này về trạng thái chờ tính lại?')) return

    setProcessingId('batch-all')

    try {
      const response = await batchRecalculateReward(cookies.lottmekong, {
        resultId: queryObj.resultId
      })

      if (response && response.status === 1) {
        alert(`${response.message || 'Tính thưởng lại thành công'}${response.skippedCount ? `\nBỏ qua: ${response.skippedCount} vé` : ''}`)
        refreshData()
      } else {
        alert(response?.message || 'Lỗi tính lại thưởng')
      }
    } catch (error) {
      alert('Lỗi tính lại thưởng')
    }

    setProcessingId('')
  }

  return (
    <>
      {(selectedIds.length > 0 || eligibleIds.length > 0) && (
        <Card border="light" className="shadow-sm mb-3">
          <Card.Body className="d-flex align-items-center justify-content-between">
            <span>Đã chọn <strong>{selectedIds.length}</strong> / {eligibleIds.length} vé có thể tính thưởng lại</span>
            <div className="d-flex gap-2">
              <Button
                variant="warning"
                disabled={processingId === 'batch-selected' || selectedIds.length === 0}
                onClick={onBatchRecalculateSelected}
              >
                {processingId === 'batch-selected' ? 'Đang xử lý' : 'Tính thưởng lại đã chọn'}
              </Button>
              <Button
                variant="danger"
                disabled={processingId === 'batch-all' || eligibleIds.length === 0}
                onClick={onBatchRecalculateAll}
              >
                {processingId === 'batch-all' ? 'Đang xử lý' : 'Tính thưởng lại toàn bộ'}
              </Button>
            </div>
          </Card.Body>
        </Card>
      )}
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">
                <Form.Check
                  type="checkbox"
                  checked={isAllSelected}
                  disabled={eligibleIds.length === 0}
                  onChange={onSelectAll}
                />
              </th>
              <th scope="col">Người chơi</th>
              <th scope="col">Mã đơn</th>
              <th scope="col">Cách chơi</th>
              <th scope="col">Dãy số</th>
              <th scope="col">Giá trị</th>
              <th scope="col">Trạng thái</th>
              <th scope="col">Tiền thưởng</th>
              <th scope="col">Chi tiết</th>
              <th scope="col">Ngày xuất</th>
            </tr>
          </thead>
          <tbody>
            {state.data.list && state.data.list.map((pv, index) => (
              <TableRow
                rIndex={index}
                key={`table-keys-lottmekong-${pv.id}`}
                isSelected={selectedIds.includes(pv.id)}
                onSelect={onSelect}
                {...pv}
              />
            ))}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};

export default React.memo(_Table)
